/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAppointment} from '../api'

 export const useQueryGetAppointment = createReactQueryHook('getAppointment', getAppointment)
